var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookIconColored = function SvgFacebookIconColored(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M20 12a8 8 0 1 0-9.25 7.9v-5.59H8.73V12h2.03v-1.76c0-2 1.19-3.12 3.02-3.12.87 0 1.79.16 1.79.16v1.97h-1.01c-1 0-1.3.62-1.3 1.25V12h2.21l-.35 2.31h-1.87v5.6A8 8 0 0 0 20 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.12 14.31.35-2.31h-2.22v-1.5c0-.63.31-1.25 1.3-1.25h1.01V7.28s-.91-.16-1.79-.16c-1.82 0-3.02 1.11-3.02 3.12V12H8.73v2.31h2.03v5.6q1.24.18 2.5 0v-5.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIconColored);
export default ForwardRef;